import React, { useState } from 'react';
import TypeWriter from '../components/TypeWriter';
import './Quiz.css';
import { useNavigate } from 'react-router-dom';

const QUESTIONS = [
  {
    q: 'In Morse timing, how long is a dash relative to a dot?',
    choices: ['Same length', 'Twice as long', 'Three times as long', 'Four times as long'],
    a: 2
  },
  {
    q: 'Which symbol is commonly used in this project to separate words when encoding Morse?',
    choices: ['|', '/', '#', '~'],
    a: 1
  },
  {
    q: 'When converting text to sign gestures, what does the app do for unknown words?',
    choices: ['Attempt to spell them out using fingerspelling', 'Break the word into characters', 'Skip them silently', 'Replace with a placeholder'],
    a: 0
  },
  {
    q: 'What audio format does the app generate for downloadable Morse tones?',
    choices: ['WAV (uncompressed)', 'MP3 (compressed)', 'OGG (open)', 'Base64 audio blob'],
    a: 0
  },
  {
    q: 'On the Signal Hub, uploading a gesture MP4 returns predictions — what are these predictions?',
    choices: ['Dominant hand color', 'Frame timestamps', 'Recognized gesture labels (text)', 'Audio transcript'],
    a: 2
  }
];

const Quiz = () => {
  const [index, setIndex] = useState(0);
  const [answers, setAnswers] = useState(Array(QUESTIONS.length).fill(null));
  const navigate = useNavigate();

  const select = (choiceIndex) => {
    const copy = answers.slice();
    copy[index] = choiceIndex;
    setAnswers(copy);
  };

  const next = () => {
    if (index < QUESTIONS.length - 1) setIndex(index + 1);
  };

  const prev = () => {
    if (index > 0) setIndex(index - 1);
  };

  const submit = () => {
    navigate('/learn');
  };

  const score = answers.reduce((s, ans, i) => (ans === QUESTIONS[i].a ? s + 1 : s), 0);
  const finished = answers.every(a => a !== null);

  return (
    <div className="quiz-page">
      <div className="quiz-card">
        <h2>
          <TypeWriter 
            text="SignCrypt Quick Quiz" 
            speed={85} 
            cursorColor="var(--color-heading)"
          />
        </h2>
        <p className="muted">Test your knowledge — {index + 1}/{QUESTIONS.length}</p>

        {!finished ? (
          <div className="question-block">
            <h3>{QUESTIONS[index].q}</h3>
            <div className="choices">
              {QUESTIONS[index].choices.map((c, i) => (
                <button key={i} className={`choice ${answers[index] === i ? 'selected' : ''}`} onClick={() => select(i)}>{c}</button>
              ))}
            </div>

            <div className="quiz-nav">
              <button className="btn btn-secondary" onClick={prev} disabled={index === 0}>Previous</button>
              {index < QUESTIONS.length - 1 ? (
                <button className="btn btn-primary" onClick={next} disabled={answers[index] === null}>Next</button>
              ) : (
                <button className="btn btn-primary" onClick={() => { if (finished) submit(); else alert('Please answer all questions'); }} disabled={answers[index] === null}>Finish</button>
              )}
            </div>
          </div>
        ) : (
          <div className="result-block">
            <h3>Your score: {score} / {QUESTIONS.length}</h3>
            <p>{score === QUESTIONS.length ? 'Perfect! You know SignCrypt well.' : 'Nice work — review any sections in Learn to improve.'}</p>
            <div className="result-actions">
              <button className="btn btn-secondary" onClick={() => { setIndex(0); setAnswers(Array(QUESTIONS.length).fill(null)); }}>Retake Quiz</button>
              <button className="btn btn-primary" onClick={() => navigate('/learn')}>Back to Learn</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Quiz;
